const globals = {
  imageBasePath: '/assets/images/v002_',
  logosBasePath: '/assets/icons/v002_',
}

export default globals
